module.exports = __webpack_public_path__ + "img/wxxcx.2e64dcb7.jpg";